import type { ThemeOptions } from '@mui/material';
import themesByAppName from 'canvas_themes/themesByAppName';

/**
 * Fetches the partner/appName themes from the shell build directory
 * @see `compileThemeFiles` in `webpack.shell.config.js` to add new appNames
 * to the compile step
 */
export const fetchThemesByPid = async (appName?: string, pid?: string): Promise<ThemeOptions[]> => {
  if (appName && appName in themesByAppName) {
    const themes = await fetchThemeFiles(appName);
    return [themes.common, themes[pid ?? '']].filter(Boolean);
  }

  return await Promise.resolve([]);
};

export const fetchThemeFiles = async (appName?: string) => {
  const { default: themes } = await themesByAppName[appName as keyof typeof themesByAppName]();
  return themes;
};
